<template>
  <Documents :hasFilterContact="true"/>
</template>

<script>
import Documents from '@/views/documents/Documents'

export default {
  name: "DocumentsContact",
  components: {
    Documents
  },
}
</script>
